/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pink_Game_Trout_FulfillInputs */

const fr_pink_game_trout_fulfill = /** @type {(inputs: Pink_Game_Trout_FulfillInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher sur l'application`)
};

/**

* @param {Pink_Game_Trout_FulfillInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const pink_game_trout_fulfill = /** @type {((inputs?: Pink_Game_Trout_FulfillInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pink_Game_Trout_FulfillInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_pink_game_trout_fulfill(inputs)
});